<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header" :data="popupData"
                  :row-class-name="toggleCheckClass" style="width: 100%;" height="695" empty-text="데이터가 없습니다." @selection-change="tableSelectChange">
            <el-table-column
                    type="selection"
                    class-name="text-center"
                    min-width="25">
            </el-table-column>
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    min-width="70"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column
                    label="상태" width="100" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnStatusName(scope.row.p_is_display)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="노출기간" min-width="100" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnUseDate(scope.row)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="작성일자" min-width="140" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="옵션" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button
                                @click="goDetail(scope.row.p_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    export default {
        name: "PopupListDefaultLayout",
        mixins: [],
        components: {},
        inject: ['popupListSetData'],
        props: {
            popupData: {default: () => []},
            paginationData: {
                default: () => { return { total: 0, page: 0, size: 0, }}
            },
        },
        data() {
            return {
                selectArr: [],
            }
        },
        created() {},
        mounted() {},
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
            tableSelectChange(row) {
                this.selectArr = [];
                util.Array.each(row, (obj, index, arr) => {
                    this.selectArr.push(obj.p_idx);
                });
                this.popupListSetData('selectArr', this.selectArr)
            },
            // 선택된 로우만 클래스 추가/제거 로직
            toggleCheckClass({row, rowIndex}) {
                return this.selectArr.indexOf(row.ce_idx) > -1 ? 'select' : '';
            },
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            returnStatusName(status) {
                return status === 1 ? '사용' : '미사용';
            },
            returnUseDate(popup) {
                if(util.isEmpty(popup.p_start) || util.isEmpty(popup.p_end)) {
                    return '';
                }
                return `${popup.p_start.split(' ')[0]} ~ ${popup.p_end.split(' ')[0]}`
            },
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment(date).format('YYYY-MM-DD HH:mm')
            },
            goDetail(idx) {
                this.$router.push(`/service/popup/${idx}`);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
